import React from 'react';

import { SVGPropsType } from 'src/types';

function Edit(props: SVGPropsType) {
    const { stroke, fill, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M9.92096 4.93515C10.3394 4.51673 11.0178 4.51673 11.4362 4.93515C11.8546 5.35357 11.8546 6.03196 11.4362 6.45038L11.0114 6.87514L9.49619 5.35992L9.92096 4.93515Z"
                fill={fill}
            />
            <path
                d="M8.73858 6.11753L4.25 10.6061V12.1213H5.76523L10.2538 7.63276L8.73858 6.11753Z"
                fill={fill}
            />
            <rect
                x="0.3"
                y="0.671338"
                width="15.4"
                height="15.4"
                rx="2.7"
                stroke={stroke}
                strokeWidth="0.6"
            />
        </svg>
    );
}

export default Edit;
